/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb2niw_Point_1_LabelInputs */

const en_visa_eb2niw_point_1_label = /** @type {(inputs: Visa_Eb2niw_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`National Importance Analysis`)
};

const pt_visa_eb2niw_point_1_label = /** @type {(inputs: Visa_Eb2niw_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise de Importância Nacional`)
};

const es_visa_eb2niw_point_1_label = /** @type {(inputs: Visa_Eb2niw_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis de Importancia Nacional`)
};

/**
* | output |
* | --- |
* | "National Importance Analysis" |
*
* @param {Visa_Eb2niw_Point_1_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb2niw_point_1_label = /** @type {((inputs?: Visa_Eb2niw_Point_1_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb2niw_Point_1_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb2niw_point_1_label(inputs)
	if (locale === "es") return es_visa_eb2niw_point_1_label(inputs)
	return en_visa_eb2niw_point_1_label(inputs)
});